import { createContext, useContext, useState } from "react";

const ActivityLogContext = createContext();

export const ActivityLogProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
    users: [],
    actions: [],
    statuses: [],
    protocols: [],
    departments: [],
    nctIds: [],
  });

  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 20,
  });

  const [sort, setSort] = useState({
    orderBy: "timestamp",
    order: "desc",
  });

  const [initialLoad, setInitialLoad] = useState(true);

  const resetFilters = () => {
    setFilters({
      startDate: null,
      endDate: null,
      users: [],
      actions: [],
      statuses: [],
      protocols: [],
      departments: [],
      nctIds: [],
    });
    setInitialLoad(false);
  };

  const value = {
    filters,
    setFilters,
    pagination,
    setPagination,
    sort,
    setSort,
    initialLoad,
    setInitialLoad,
    resetFilters,
  };

  return (
    <ActivityLogContext.Provider value={value}>
      {children}
    </ActivityLogContext.Provider>
  );
};

export const useActivityLogContext = () => {
  const context = useContext(ActivityLogContext);
  if (!context) {
    throw new Error(
      "useActivityLogContext must be used within ActivityLogProvider"
    );
  }
  return context;
};
